import React from "react";

/* The six-dot grip on a reorderable row. Decorative — the row it sits on
   carries the drag behaviour and its own accessible name. */
export const DragHandleIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    {[8, 12, 16].map((y) => (
      <React.Fragment key={y}>
        <circle cx="9.5" cy={y} r="1.35" fill="currentColor" />
        <circle cx="14.5" cy={y} r="1.35" fill="currentColor" />
      </React.Fragment>
    ))}
  </svg>
);

export default DragHandleIcon;
